import React, { useRef, useEffect, useState } from "react";
import { MdCreditScore } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";

const TenantModificationModal = ({
  setShowPay,
  fieldToShow,
  tenantData,
  houseNumbers = [1,2,3,4,5],
}) => {
  const modalRef = useRef();
  const [isClosing, setIsClosing] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [selectedHouseNumber, setSelectedHouseNumber] = useState("");

  console.log("Tenant info", tenantData);
  // Tenant state for the form
  const [tenantInfo, setTenantInfo] = useState({
    firstName: tenantData.firstName,
    lastName: tenantData.lastName,
    email: tenantData.email,
    phoneNumber: tenantData.phoneNumber,
    emergencyContact: "",
    nationalId: tenantData.nationalID,
  });

  // Check if the screen is small
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Small and medium screens
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Handle closing the modal
  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => setShowPay(false), 300); // Slight delay for close animation
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTenantInfo((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  // House selection for edit tenant unspecified
  const handleHouseSelection = (e) => {
    setSelectedHouseNumber(e.target.value);
    setTenantInfo({
      id: "T001",
      name: "Timothy Ndiritu",
      dateJoined: "April 2024",
      apartmentNumber: "A15",
      email: "timothy.ndiritu@example.com",
      phoneNumber: "+254700123456",
      houseType: "2 Bedroom",
      nationalID: "12345678",
    })
  };

  // Modal content based on the fieldToShow
  const renderModalContent = () => {
    if (fieldToShow === "create new tenant") {
      return (
        <form>
          <input style={styles.input} type="text" placeholder="Full Names" />
          <input style={styles.input} type="email" placeholder="Email" />
          <input style={styles.input} type="number" placeholder="National ID" />
          <input
            style={styles.input}
            type="number"
            placeholder="Phone Number"
          />
          <input
            style={styles.input}
            type="number"
            placeholder="Paid Deposit"
          />
          <input
            style={styles.input}
            type="number"
            placeholder="Unpaid Deposit"
          />
          <input style={styles.input} type="number" placeholder="Arrears" />
          <input
            style={styles.input}
            type="number"
            placeholder="Unpaid Water Bills"
          />
          <select style={styles.input} name="houseNumber">
            <option value="">Select House Number</option>
            {houseNumbers.map((house, index) => (
              <option key={index} value={house}>
                {house}
              </option>
            ))}
          </select>
          <button style={styles.button} type="submit">
            Create Tenant
          </button>
        </form>
      );
    }

    if (fieldToShow === "modify tenant") {
      return (
        <form>
          <div style={styles.sideBySide}>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={tenantInfo.firstName}
              style={{ ...styles.input, marginBottom: "10px" }}
              onChange={handleInputChange}
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={tenantInfo.lastName}
              style={{ ...styles.input, marginBottom: "10px" }}
              onChange={handleInputChange}
            />
          </div>
          <input
            type="email"
            name="email"
            placeholder="Email"
            style={styles.input}
            value={tenantInfo.email}
            onChange={handleInputChange}
          />
          <input
            type="number"
            name="phoneNumber"
            placeholder="Phone Number"
            style={styles.input}
            value={tenantInfo.phoneNumber}
            onChange={handleInputChange}
          />
          <input
            type="number"
            name="emergencyContact"
            placeholder="Emergency Contact"
            value={tenantInfo.emergencyContact}
            style={styles.input}
            onChange={handleInputChange}
          />
          <input
            type="number"
            name="nationalId"
            placeholder="National ID Number"
            value={tenantInfo.nationalId}
            style={styles.input}
            onChange={handleInputChange}
          />
          <button style={styles.button} type="submit">Save Changes</button>
        </form>
      );
    }

    if (fieldToShow === "delete tenant") {
      if (Object.keys(tenantData).length === 0) {
        // tenantData is an empty object
        return (
          <div>
            <p>Select house number to delete tenant</p>
            <select onChange={(e) => handleHouseSelection(e)}>
              <option value="">Select house number</option>
              {houseNumbers.map((house) => (
                <option key={house} value={house}>
                  {house}
                </option>
              ))}
            </select>
          </div>
        );
      } else {
        // tenantData contains data
        return (
          <div>
            <p>
              Are you sure you want to delete tenant {tenantData.firstName} of
              tenant ID {tenantData.tenantId}?
            </p>
            <div style={styles.sideBySide}>
              <button
                style={styles.confirm}
                onClick={() => console.log("Tenant deleted!")}
              >
                Confirm
              </button>
              <button style={styles.cancel} onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        );
      }
    }
    
    

    if (fieldToShow === "edit tenant unspecified") {
      return (
        <div>
          <select name="houseNumber" onChange={handleHouseSelection}>
            <option value="">Select House Number</option>
            {houseNumbers.map((house, index) => (
              <option key={index} value={house}>
                {house}
              </option>
            ))}
          </select>
          {selectedHouseNumber && (
            <form>
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={tenantInfo.firstName}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={tenantInfo.lastName}
                onChange={handleInputChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={tenantInfo.email}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number"
                value={tenantInfo.phoneNumber}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="emergencyContact"
                placeholder="Emergency Contact"
                value={tenantInfo.emergencyContact}
                onChange={handleInputChange}
              />
              <input
                type="text"
                name="nationalId"
                placeholder="National ID Number"
                value={tenantInfo.nationalId}
                onChange={handleInputChange}
              />
              <button type="submit">Save Changes</button>
            </form>
          )}
        </div>
      );
    }
  };

  if (!isSmallScreen) return null; // Return nothing if it's not a small/medium screen

  return (
    <div style={styles.overlay}>
      <div style={styles.modalContent} ref={modalRef}>
        <button style={styles.closeBtn} onClick={closeModal}>
          &times;
        </button>
        {renderModalContent()}
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)", // Dark translucent overlay
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modalContent: {
    backgroundColor: "white",
    padding: "40px 20px 20px 20px",

    borderRadius: "8px",
    width: "90%", // Adapt to smaller screens
    maxWidth: "500px",
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
    position: "relative",
    zIndex: 10000, // Ensure it's above the overlay
    animation: "fadeIn 0.3s ease",
  },
  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "15px",
    fontSize: "24px",
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  button: {
    width: "100%",
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#192A3A",
    color: "white",
    cursor: "pointer",
  },
  sideBySide: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    alignItems: "center",
  },
  confirm: {
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#192A3A",
    color: "white",
    cursor: "pointer",
    width: "50%",
  },
  cancel: {
    padding: "10px",
    borderRadius: "5px",
    border: "none",
    backgroundColor: "#B39359",
    color: "white",
    cursor: "pointer",
    width: "50%",
  },

};

export default TenantModificationModal;
